function sponsoredFinanceAdService ($http) {

    return {
        getLoanRates,
        getLoanRatePerMonths
    };

    function getLoanRates() {
        let url = "/ajax/vehicleloanrate/1.0/rest/rates";

        return $http.get(url, {cache : true});
    }

    function getLoanRatePerMonths (months) {
        let url = "/ajax/vehicleloanrate/1.0/rest/rates/" + months;

        return $http.get(url, {cache : true});
    }

}

sponsoredFinanceAdService.$inject = [
    '$http'
];

export default sponsoredFinanceAdService;
